import * as React from "react";
import { useHistory } from "react-router";

import { useAccountSettings, URLS, useSocialCoachSession, STORAGE_KEYS } from "@/utils";
import { WebComponents } from "@/interfaces";
import "./styles.scss";
import { PageWrapper } from "@/components/PageWrapper";
import { CampaignListContent } from "@/components/Lists";

export const Campaigns: React.FC = () => {
  const history = useHistory();
  const { coachId } = useSocialCoachSession();
  const { hasWritePermission } = useAccountSettings();
  const writePermission = hasWritePermission(WebComponents.CAMPAIGNS);

  const addCampaignHandler = () => {
    localStorage.removeItem(STORAGE_KEYS.COACH_NEW_CAMPAIGN_STEP);
    localStorage.removeItem(STORAGE_KEYS.COACH_CAMPAIGN);
    history.push(URLS.coach.newCampaigns);
  };

  const actions = writePermission
    ? [
        {
          text: "New Campaign",
          onClick: addCampaignHandler,
        },
      ]
    : [];

  return (
    <PageWrapper title="Campaigns" actions={actions}>
      {coachId && <CampaignListContent coachId={coachId.toString()} />}
    </PageWrapper>
  );
};
